import { Entity } from "ecsy";
import { Player } from "../components/player";
import Camera from "../components/camera";
import DisposableSystem from "@/game/libs/engine/root/disposable-system";
import { PlayerDirection } from "@/game/skifree/controller/Controller";

export default class CameraSystem extends DisposableSystem<any> {
  execute(delta: number, time: number) {
    var playerEntity: Entity = this.queries.player.results[0];
    var cameraEntity: Entity = this.queries.camera.results[0];

    if (playerEntity && cameraEntity) {
      var camera = cameraEntity.getComponent(Camera);
      var player = playerEntity.getComponent(Player);

      camera.stage.x = -player.x + camera.width / 2;
      camera.stage.y = -player.y + camera.height / 3.2;

      // camera.stage.x = this.getVal(
      //   true,
      //   camera.width / 2,
      //   player.x,
      //   camera.stage.x,
      //   player.direction
      // );
      // camera.stage.y = this.getVal(
      //   false,
      //   camera.height / 2,
      //   player.y,
      //   camera.stage.y,
      //   player.direction
      // );
    }
  }

  getVal(
    isX: boolean,
    mid: number,
    playerCur: number,
    stageCur: number,
    direction: PlayerDirection
  ): number {
    var offset = 0;
    if (isX) {
      switch (direction) {
        case PlayerDirection.FACE_LEFT:
          offset = 60;
          break;
        case PlayerDirection.FACE_SLIGHT_LEFT:
          offset = 25;
          break;
        case PlayerDirection.FACE_SLIGHT_RIGHT:
          offset = -25;
          break;
        case PlayerDirection.FACE_RIGHT:
          offset = -60;
          break;
      }
    } else {
      offset = -100;
    }
    var target = -playerCur + mid + offset;
    var distX = target - stageCur;
    var percentage = distX == 0 ? 1 : Math.abs(distX) / 400;
    if (!this._hasStarted) {
      this._hasStarted = true;
      return (stageCur += distX);
    }
    stageCur += percentage * distX;
    return stageCur;
  }

  public dispose() {}

  private _hasStarted: boolean = false;
}

(CameraSystem as any).queries = {
  player: {
    components: [Player]
  },
  camera: {
    components: [Camera]
  }
};
